import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ActivationView } from './auth/ActivationView';
import { ProfileMenuAutoClose } from './dashboard/ProfileMenuAutoClose';
import './styles/base.css';
import './styles/layout.css';
import './styles/modules.css';
import './styles/modules-auth-activation.css';
import './styles/modules-app-shell.css';
import './styles/modules-passkey-management.css';
import './styles/modules-my-account.css';
import './styles/modules-freebe-schedule.css';
import './styles/modules-client-directory.css';
import './styles/modules-client-activity.css';
import './styles/modules-business-logo.css';
import './styles/modules-financial-overview.css';
import './styles/modules-remuneration.css';
import './styles/modules-revenue.css';
import './styles/modules-treasury.css';
import './styles/modules-expenses.css';
import './styles/modules-finance-loading.css';
import './styles/modules-finance-controls.css';
import './styles/modules-page-heading.css';
import './styles/modules-hosting-servers.css';
import './styles/modules-hosting-technologies.css';
import './styles/modules-hosting-providers.css';
import './styles/modules-hosting-plesk.css';
import './styles/modules-hosting-sites.css';
import './styles/modules-hosting-backups.css';
import './styles/modules-global-search.css';
import './styles/states.css';
import './styles/states-feedback.css';
import './styles/themes.css';
import './styles/custom.css';
import './styles/custom-connected-v22.css';
import './styles/custom-connected-v22-responsive.css';
import './styles/custom-connected-v22-responsive-search.css';
import './styles/custom-connected-v22-modal.css';
import './styles/custom-s1-08-mobile-overflow.css';

const root = document.querySelector<HTMLDivElement>('#root');
if (!root) throw new Error("Le point de montage de l'application est absent.");

const content =
  window.location.pathname === '/activation' ? (
    <ActivationView onReturnToLogin={() => window.location.assign('/')} />
  ) : (
    <App />
  );

createRoot(root).render(
  <StrictMode>
    <ProfileMenuAutoClose />
    {content}
  </StrictMode>,
);
